export default __webpack_public_path__ + "static/Baked3-cd000e6129e1d9d6d752dfee0adb1d0f.png";